var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsNumber, IsOptional, IsString, IsUUID, } from 'class-validator';
import { OfficeFullSizeDto } from '../../offices/index.js';
import { PaymentFullSizeDto } from '../../payment/payment.full-size.dto.js';
import { PreventionCourseApprovalFullSizeDto } from './prevention-course-approval.full-size.dto.js';
import { PreventionCourseModuleFullSizeDto } from './prevention-course-module.full-size.dto.js';
import { PreventionCourseVoucherFullSizeDto } from './prevention-course-voucher.full-size.dto.js';
export class PreventionCourseFullSizeDto {
    id;
    createdAt;
    updatedAt;
    title;
    thumbnailImage;
    price;
    shortDescription;
    longDescription;
    contactName;
    contactEmail;
    contactImg;
    preventionCourseModules;
    preventionCourseVouchers;
    stripePriceId;
    stripeAccountId; // if null, then course is from therame
    preventionCourseApprovals;
    payments;
    owned;
    enrollmentDate;
    paymentEnabled;
    vouchersEnabled;
    visibilityPublic;
    sharedWithOffices;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionCourseFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionCourseFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PreventionCourseFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseFullSizeDto.prototype, "title", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", Object)
], PreventionCourseFullSizeDto.prototype, "thumbnailImage", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], PreventionCourseFullSizeDto.prototype, "price", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseFullSizeDto.prototype, "shortDescription", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseFullSizeDto.prototype, "longDescription", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseFullSizeDto.prototype, "contactName", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseFullSizeDto.prototype, "contactEmail", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseFullSizeDto.prototype, "contactImg", void 0);
__decorate([
    IsArray(),
    Expose(),
    Type(() => PreventionCourseModuleFullSizeDto),
    __metadata("design:type", Array)
], PreventionCourseFullSizeDto.prototype, "preventionCourseModules", void 0);
__decorate([
    IsArray(),
    Type(() => PreventionCourseVoucherFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], PreventionCourseFullSizeDto.prototype, "preventionCourseVouchers", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseFullSizeDto.prototype, "stripePriceId", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], PreventionCourseFullSizeDto.prototype, "stripeAccountId", void 0);
__decorate([
    IsArray(),
    Exclude(),
    Type(() => PreventionCourseApprovalFullSizeDto),
    __metadata("design:type", Array)
], PreventionCourseFullSizeDto.prototype, "preventionCourseApprovals", void 0);
__decorate([
    IsArray(),
    Exclude(),
    Type(() => PaymentFullSizeDto),
    __metadata("design:type", Array)
], PreventionCourseFullSizeDto.prototype, "payments", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], PreventionCourseFullSizeDto.prototype, "owned", void 0);
__decorate([
    IsDateString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Date)
], PreventionCourseFullSizeDto.prototype, "enrollmentDate", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], PreventionCourseFullSizeDto.prototype, "paymentEnabled", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], PreventionCourseFullSizeDto.prototype, "vouchersEnabled", void 0);
__decorate([
    IsBoolean(),
    Exclude(),
    __metadata("design:type", Boolean)
], PreventionCourseFullSizeDto.prototype, "visibilityPublic", void 0);
__decorate([
    IsArray(),
    Type(() => OfficeFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], PreventionCourseFullSizeDto.prototype, "sharedWithOffices", void 0);
//# sourceMappingURL=prevention-course.full-size.dto.js.map